interface FeatureCollection extends GeoJSON.FeatureCollection {
  bounds: {
    longitude_left: number;
    latitude_top: number;
    longitude_right: number;
    latitude_bottom: number;
  };
}

export default function getSource(url: string): Promise<FeatureCollection> {
  return fetch(url)
    .then(res => res.json());
}
